import JitsiMeetJS from '../../../base/lib-jitsi-meet/_';
const JitsiTrackEvents = JitsiMeetJS.events.track;
const ThumbnailAudioIndicator = () => null;
export default ThumbnailAudioIndicator;
